import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TableSkeleton } from '../../components/UI/Skeleton/Skeleton';
import RowActionMenu from '../../components/UI/RowActionMenu/RowActionMenu';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import _debounce from 'lodash/debounce';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import '../../App.css';

import {
  leaveRequestApi,
  useAddLeaveRequestMutation,
  useEditLeaveRequestMutation,
  useGetLeaveCountQuery,
  useGetLeaveRequestQuery
} from '../../redux/apis/LeaveRequest';
import { useGetUserAllLeaveBalanceQuery } from '../../redux/apis/LeaveBalance';
import { useGetHolidaysQuery } from '../../redux/apis/holidayApi';
import { useGetLeaveTypeQuery } from '../../redux/apis/LeaveType';
import { useGetEmployeeQuery, useGetEmployeeDropDownQuery } from '../../redux/apis/employee';
import { useIsLoggedInQuery } from '../../redux/apis/authApi';

import EmptyData from '../../components/UI/EmptyData';
import { LeaveRequestData } from '../../components/Data/AppData';
import SingleSelectBox from '../../components/UI/SingleSelectBox';

import {
  LB_HEADER,
  LB_EMPLOYEE_TABLE_COLS,
  LB_EMPLOYEE_TABLE_COLS_SORT
} from '../../utils/constant/labels';
import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';
import { INPUT_LABEL, PLACEHOLDER } from '../../utils/constant/placeHolders';
import { leaveRequestSchema } from '../../utils/schemas/auth';
import {
  DATE_FILTER,
  DATE_FILTER_KEYS,
  GLOBAL,
  HALF_TYPE,
  HOLIDAY_TYPE,
  LEAVE_DAY_TYPE,
  LEAVE_STATUS,
  LEAVE_TYPES,
  ROLES,
  ADMIN_HR_ROLES,
  VALIDATION_DAY,
  WEEKEND_TYPE
} from '../../utils/constant/global';
import { notification } from '../../utils/notification';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';
import {
  getErrorMessage,
  formatDate,
  matchData,
  paginationRow,
  skipRow,
  editDateFormate,
  RANGES,
  fullName
} from '../../utils/handler';

import moment from 'moment';
// import DatePickerApp from '../../components/UI/DatePicker';
import DateRangePicker from '../../components/UI/DateRangePicker';
import LeaveDayBreakdown from './LeaveDayBreakdown';

import './LeaveRequest.scss';

const initialState = {
  isEditModalData: {},
  modalHeader: { title: '', isEdit: false },
  isEditModal: { status: false, id: '' },
  isView: { status: false },
  isDeleteModal: { status: false, id: '' },
  currentPage: 1,
  rowsPerPage: 10,
  isNext: false,
  leaveCount: 0,
  formResetKey: 0,
  sortField: 'createdAt',
  sortDirection: false,
  loading: false,
  dropdownDataStore: [],
  currentPageDropdown: 1,
  rowsPerPageDropdown: 50,
  reason: '',
  reasonError: '',
  rejectReason: '',
  rejectReasonError: '',
  startDate: moment().startOf('day').valueOf(),
  endDate: moment().endOf('day').valueOf(),
  leaveTypeFilter: 'all'
};

const initialCustomDateRange = {
  startDate: null,
  endDate: null,
  isCustom: false,
  startOpen: false,
  endOpen: false
};

const {
  LB_TBL_COL_EMPLOYEE_NAME,
  LB_TBL_COL_LEAVE_TYPE,
  LB_TBL_COL_FROM,
  LB_TBL_COL_TO,
  LB_TBL_COL_ACTION,
  LB_TBL_COL_STATUS,
  LB_TBL_COL_APPROVED_BY,
  LB_TBL_COL_REQUEST_DATE,
  LB_TBL_COL_DAY
  // LB_TBL_COL_LEAVE_CATEGORY,
  // LB_TBL_COL_COMMENT,
  // LB_TBL_COL_REASON
} = LB_EMPLOYEE_TABLE_COLS;
const { SR_EMPLOYEE_NAME, SR_LEAVE_TYPE } = LB_EMPLOYEE_TABLE_COLS_SORT;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { ADMIN, HR, ACCOUNTANT } = ROLES;
const { REJECTED, ACCEPTED, PENDING } = LEAVE_STATUS;
const {
  LB_ADD_LEAVE_REQUEST,
  LB_APPROVE,
  LB_ASK_LEAVE_APPROVE,
  LB_REJECT,
  LB_ASK_LEAVE_REJECT,
  LB_EDIT_LEAVE_REQUEST,
  // LB_TBL_COL_TOTAL_LEAVE,
  LB_LEAVE_REQUEST
} = LB_HEADER;
const { PH_LEAVE_REASON, PH_SELECT_LEAVE_TYPE, PH_SEARCH_INPUT } = PLACEHOLDER;
const { BTN_SAVE, BTN_ACCEPT, BTN_REJECT: REJECT_BTN, BTN_APPLY_LEAVE } = BT_BUTTON_LABELS;
const {
  LB_LEAVE_REASON,
  LB_TBL_COL_TO_DATA,
  LB_TBL_COL_FROM_DATE,
  LB_TBL_COL_LEAVE_TYPE: LEAVE_TYPE_INPUT_LABEL,
  LB_USER
} = INPUT_LABEL;
const { DESC, ASC } = GLOBAL;
const { SUN, SAT, F_HALF, S_HALF, HALF_DAY, FULL_DAY } = VALIDATION_DAY;

const LEAVE_AVATAR_TONES = ['indigo', 'teal', 'amber', 'rose', 'sky'];

const getLeaveInitials = (name = '') => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
};

const getLeaveAvatarTone = (name = '') => {
  const source = String(name);
  let hash = 0;
  for (let i = 0; i < source.length; i += 1) {
    hash = (hash + source.charCodeAt(i)) % LEAVE_AVATAR_TONES.length;
  }
  return LEAVE_AVATAR_TONES[hash];
};

const LeaveStatusPill = ({ status }) => {
  const key = status === ACCEPTED ? 'approved' : status === REJECTED ? 'rejected' : 'pending';
  const label = status === ACCEPTED ? 'Approved' : status === REJECTED ? 'Rejected' : 'Pending';
  return <span className={`leave-status leave-status--${key}`}>{label}</span>;
};

const LeaveApprovedByCell = ({ row }) => {
  const status = row?.leaveStatus;
  const reviewer = String(row?.approvedBy?.name || '').trim();
  const isDecided = status === ACCEPTED || status === REJECTED;

  if (!isDecided || !reviewer) {
    return <span className="leave-approved-by leave-approved-by--empty">—</span>;
  }

  return (
    <div className="leave-approved-by" title={reviewer}>
      <span
        className={`leave-approved-by__avatar leave-approved-by__avatar--${getLeaveAvatarTone(reviewer)}`}
        aria-hidden="true"
      >
        {getLeaveInitials(reviewer)}
      </span>
      <span className="leave-approved-by__name">{reviewer}</span>
    </div>
  );
};

const formatLeaveUnit = (unit, count) => {
  const raw = String(unit || 'days').toLowerCase();
  const amount = Number(count);
  if (raw.includes('hour')) return amount === 1 ? 'Hour' : 'Hours';
  if (raw.includes('day')) return amount === 1 ? 'Day' : 'Days';
  const cleaned = String(unit || 'Days')
    .replace(/[()]/g, '')
    .trim();
  return cleaned || 'Days';
};

const LeaveTableDate = ({ value }) => {
  const label = formatDate(value);
  const parsed = value ? moment(value) : null;
  if (!parsed || !parsed.isValid() || label === '-') {
    return <span className="leave-date leave-date--empty">-</span>;
  }

  return (
    <span className="leave-date">
      <span className="leave-date__d">{parsed.format('DD')}</span>
      <span className="leave-date__my">{parsed.format('MMM YYYY')}</span>
    </span>
  );
};

const isFullDayOnlyLeaveType = (leaveTypeName = '') => {
  const normalized = leaveTypeName.trim().toLowerCase();
  return normalized.includes('early exit') || normalized.includes('late arrival');
};

const isUsageTrackedLeaveType = (leaveTypeName = '') => {
  return leaveTypeName === LEAVE_TYPES.WFH || leaveTypeName === LEAVE_TYPES.UNPAID_LEAVES;
};

const getLeaveBalanceMetrics = (leaveType = {}) => {
  const used = Number(leaveType?.bookedBalance) || 0;
  const balanceFromApi = Number(leaveType?.availableBalance) || 0;

  if (isUsageTrackedLeaveType(leaveType?.name)) {
    const total = balanceFromApi;
    const available = Math.max(total - used, 0);
    return { used, available, total };
  }

  const available = balanceFromApi;
  const total = available + used;
  return { used, available, total };
};

function LeaveRequest() {
  const dispatch = useDispatch();
  const [state, setState] = useState(initialState);
  const { data: isLogin } = useIsLoggedInQuery();
  const roleName = isLogin?.data?.hrxRole?.roleName;
  const isAdminOrHr = ADMIN_HR_ROLES.includes(roleName);
  const canReviewLeave = roleName === ADMIN || roleName === HR;
  const [customDateRange, setCustomDateRange] = useState(initialCustomDateRange);

  /* const renderClampedTextCell = (text, tooltipId) => {
    const value = typeof text === 'string' && text.trim() ? text.trim() : '-';
    if (value === '-') {
      return <div className="reason-cell">-</div>;
    }

    return (
      <OverlayTrigger
        placement="top"
        trigger={['hover', 'focus']}
        overlay={
          <Tooltip className="reason-tooltip" id={tooltipId}>
            {value}
          </Tooltip>
        }
      >
        <div className="reason-cell" title={value}>
          {value}
        </div>
      </OverlayTrigger>
    );
  }; */

  /*   const getLeaveTypeShortLabel = (name = '') => {
    return name.toUpperCase();
  }; */

  const leaveRequestTableStyles = {
    table: {
      style: {
        backgroundColor: 'transparent',
        minHeight: 'auto'
      }
    },
    headRow: {
      style: {
        backgroundColor: '#f8fafc',
        borderTopLeftRadius: '0',
        borderTopRightRadius: '0',
        borderBottom: '1px solid #e9edf3',
        minHeight: '48px'
      }
    },
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: '11px',
        color: '#334155',
        textTransform: 'uppercase',
        letterSpacing: '0.06em'
      }
    },
    rows: {
      style: {
        minHeight: '72px',
        borderBottom: '1px solid #f1f4f8',
        backgroundColor: '#ffffff',
        color: '#6b7280'
      },
      highlightOnHoverStyle: {
        backgroundColor: '#f5f6fb',
        borderBottomColor: '#e9edf3',
        outline: 'none'
      }
    },
    cells: {
      style: {
        color: '#6b7280',
        fontWeight: 600,
        fontSize: '13px',
        paddingTop: '10px',
        paddingBottom: '10px'
      }
    },
    pagination: {
      style: {
        borderTop: '1px solid #f1f4f8',
        paddingTop: '10px',
        paddingBottom: '10px'
      }
    }
  };

  const [tabClick, setTabClick] = useState(PENDING);
  const [periodFilter, setPeriodFilter] = useState(DATE_FILTER_KEYS.TODAY);

  const {
    data: leaveTypeData
    // refetch: getLeaveType
  } = useGetLeaveTypeQuery({ search: '' });

  const {
    //data: employeeData,
    // eslint-disable-next-line no-unused-vars
    refetch: refetchEmployee
  } = useGetEmployeeQuery(
    {
      search: '',
      skip: skipRow(state.currentPage, state.rowsPerPage),
      limit: state.rowsPerPage
    },
    { skip: !isAdminOrHr }
  );

  const {
    data: dropdownData,
    refetch: employeeDropDownQuery,
    isFetching: isEmployeeDropdownFetching
  } = useGetEmployeeDropDownQuery({
    search: '',
    skip: skipRow(state.currentPageDropdown, state.rowsPerPageDropdown),
    limit: state.rowsPerPageDropdown
  });

  const employeeOptions = (
    state.dropdownDataStore?.length ? state.dropdownDataStore : dropdownData?.data || []
  ).map((val) => ({
    value: val._id,
    label: val.name || fullName(val)
  }));

  const openLeaveRequestModal = ({ title, isEditModalData = {} }) => {
    setState((prevState) => ({
      ...prevState,
      modalHeader: { title, isEdit: true },
      isEditModalData,
      currentPageDropdown: 1,
      dropdownDataStore: []
    }));
    employeeDropDownQuery();
  };

  const handleEmployeeMenuOpen = () => {
    if (!isAdminOrHr) return;
    if (employeeOptions.length === 0) {
      employeeDropDownQuery();
    }
  };

  const buildLeaveRequestArgs = (overrides = {}) => {
    const page = overrides.page ?? state.currentPage;
    const leaveTypeFilter = overrides.leaveTypeFilter ?? state.leaveTypeFilter;

    return {
      status: overrides.status ?? tabClick,
      search: overrides.search ?? state.search,
      skip: skipRow(page, state.rowsPerPage),
      limit: state.rowsPerPage,
      sort: state.sortField,
      sortType: state.sortDirection ? DESC : ASC,
      userId: [ADMIN, HR, ACCOUNTANT].includes(roleName) ? undefined : isLogin?.data?._id,
      startDate: overrides.startDate ?? state.startDate,
      endDate: overrides.endDate ?? state.endDate,
      leaveTypeId: leaveTypeFilter === 'all' ? undefined : leaveTypeFilter
    };
  };

  const forceLeaveRequestFetch = (overrides = {}) => {
    dispatch(
      leaveRequestApi.endpoints.getLeaveRequest.initiate(buildLeaveRequestArgs(overrides), {
        forceRefetch: true,
        subscribe: false
      })
    );
  };

  const leaveRequestQueryArgs = useMemo(
    () => buildLeaveRequestArgs({ page: state.currentPage }),
    [
      tabClick,
      state.search,
      state.currentPage,
      state.rowsPerPage,
      state.sortField,
      state.sortDirection,
      state.startDate,
      state.endDate,
      state.leaveTypeFilter,
      roleName,
      isLogin?.data?._id
    ]
  );

  const {
    data,
    isLoading,
    isFetching,
    refetch: leaveRequestRefetch
  } = useGetLeaveRequestQuery(leaveRequestQueryArgs, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true
  });

  const leaveCountQueryArgs = useMemo(
    () => ({
      userId: [ADMIN, HR, ACCOUNTANT].includes(roleName) ? undefined : isLogin?.data?._id,
      startDate: state.startDate,
      endDate: state.endDate,
      leaveTypeId: state.leaveTypeFilter === 'all' ? undefined : state.leaveTypeFilter
    }),
    [roleName, isLogin?.data?._id, state.startDate, state.endDate, state.leaveTypeFilter]
  );

  const { data: leaveCountResponse, refetch: leaveCountRefetch } = useGetLeaveCountQuery(
    leaveCountQueryArgs,
    {
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true
    }
  );

  const leaveCounts = leaveCountResponse?.data || {};

  const handleStatusTabChange = (status) => {
    const nextPage = 1;

    setTabClick(status);
    setState((prev) => ({
      ...prev,
      currentPage: nextPage
    }));

    forceLeaveRequestFetch({ status, page: nextPage });
  };

  const { data: leaveBalanceData, refetch: leaveBalanceRefetch } = useGetUserAllLeaveBalanceQuery(
    {
      userId: isLogin?.data?._id
    },
    { refetchOnMountOrArgChange: true, refetchOnFocus: true }
  );

  const balanceLeaveTypes = useMemo(
    () => leaveBalanceData?.data?.[0]?.leaveType || [],
    [leaveBalanceData?.data]
  );

  const visibleLeaveTypes = useMemo(() => {
    if (isAdminOrHr) return leaveTypeData?.data || [];
    return balanceLeaveTypes;
  }, [isAdminOrHr, leaveTypeData?.data, balanceLeaveTypes]);

  const visibleLeaveTypeIds = useMemo(
    () => new Set(visibleLeaveTypes.map((item) => item._id)),
    [visibleLeaveTypes]
  );

  const employeeLeaveTypes = balanceLeaveTypes;

  useEffect(() => {
    if (isAdminOrHr || state.leaveTypeFilter === 'all') return;
    if (!visibleLeaveTypeIds.has(state.leaveTypeFilter)) {
      setState((prevState) => ({ ...prevState, leaveTypeFilter: 'all', currentPage: 1 }));
    }
  }, [isAdminOrHr, state.leaveTypeFilter, visibleLeaveTypeIds]);

  const [addLeaveRequest] = useAddLeaveRequestMutation();
  const [EditLeaveRequest] = useEditLeaveRequestMutation();

  const handleChangeSort = (sortField) => {
    setState({ ...state, sortDirection: !state.sortDirection, sortField: sortField.sortField });
  };

  const defaultValue = {
    leaveTypeId: '',
    userId: '',
    startDate: '',
    endDate: '',
    note: '',
    dateOfRequest: '',
    leaveDetails: []
  };

  const {
    register,
    reset,
    setValue,
    watch,
    trigger,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(leaveRequestSchema),
    values: state.isEditModalData?._id ? state.isEditModalData : defaultValue,
    defaultValues: defaultValue
  });

  const closeLeaveRequestModal = (extraState = {}) => {
    reset(defaultValue);
    setState((prev) => ({
      ...prev,
      modalHeader: { title: '', isEdit: false },
      isEditModalData: {},
      leaveCount: 0,
      isView: { status: false },
      loading: false,
      formResetKey: prev.formResetKey + 1,
      ...extraState
    }));
  };

  useEffect(() => {
    if (!state.modalHeader?.isEdit) {
      reset(defaultValue);
    }
  }, [state.modalHeader?.isEdit, reset]);

  const openApplyLeaveModal = () => {
    reset(defaultValue);
    setState((prev) => ({
      ...prev,
      isEditModalData: {},
      leaveCount: 0
    }));
    openLeaveRequestModal({ title: LB_ADD_LEAVE_REQUEST });
  };

  const valuesData = watch();
  const selectedLeaveTypeBalance = leaveBalanceData?.data?.[0]?.leaveType?.find(
    (leaveType) => leaveType._id === valuesData.leaveTypeId
  );
  const isLeaveModalOpen = Boolean(state.modalHeader?.isEdit);
  // Preload holidays once when modal opens so date selection never waits / flickers
  const holidayQueryArgs = useMemo(
    () => ({
      startDate: moment().subtract(1, 'year').startOf('year').valueOf(),
      endDate: moment().add(1, 'year').endOf('year').valueOf(),
      limit: 500
    }),
    []
  );
  const { data: holidayDate, isSuccess: isHolidaysSuccess } = useGetHolidaysQuery(
    holidayQueryArgs,
    {
      skip: !isLeaveModalOpen
    }
  );
  // Only block dates until first successful load — cached data = no flicker on reopen/refetch
  const isHolidayDataReady = isLeaveModalOpen && isHolidaysSuccess;
  const isHolidayDataPending = isLeaveModalOpen && !isHolidaysSuccess;

  useEffect(() => {
    if (state.isEditModalData?._id) {
      const startDate = editDateFormate(state.isEditModalData?.startDate);
      const endDate = editDateFormate(state.isEditModalData?.endDate);
      setValue('startDate', startDate);
      setValue('endDate', endDate);
    }
  }, [state.isEditModalData]);

  const leaveCount = (daysList) => {
    const totalLeaveCount = daysList.reduce((total, day) => {
      const isHoliday = holidayDate?.data?.some((val) => val.date === day.date);

      const dayName = moment(day.date).format('ddd');

      // Skip Saturday, Sunday & Holiday
      if (dayName === SAT || dayName === SUN || isHoliday) {
        return total;
      }

      return total + day.leaveCount;
    }, 0);

    setValue('leaveTaken', totalLeaveCount);
    setState((prev) => ({ ...prev, leaveCount: totalLeaveCount }));
  };

  const resetLeaveDetailsToFullDay = (details = valuesData.leaveDetails) => {
    if (!details?.length) return;

    const updatedDetails = details.map((detail) => ({
      ...detail,
      isHalfDay: false,
      leaveSession: 0,
      leaveCount: 1
    }));

    setValue('leaveDetails', updatedDetails);
    leaveCount(updatedDetails);
  };

  const handleLeaveType = (val, i) => {
    if (isFullDayOnlyLeaveType(valuesData.leaveTypeName)) {
      resetLeaveDetailsToFullDay();
      return;
    }

    setValue(`leaveDetails[${i}].isHalfDay`, val === HALF_DAY ? true : false);
    setValue(`leaveDetails[${i}].leaveSession`, val === FULL_DAY ? 0 : 1);
    setValue(`leaveDetails[${i}].leaveCount`, val === HALF_DAY ? 0.5 : 1);
    leaveCount(valuesData.leaveDetails);
  };

  const calculateDays = (start, end) => {
    if (start && end) {
      let currentDate = new Date(start);
      let daysList = [];
      while (currentDate <= end) {
        // if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        const dateString = currentDate.toISOString().split('T')[0];
        const dateStemp = new Date(dateString).getTime();

        const oldId = state?.isEditModalData?.leaveDetails?.filter((val) => val.date === dateStemp);

        if (state?.isEditModalData?.leaveDetails && oldId?.length > 0) {
          daysList.push(...oldId);
        } else {
          daysList.push({
            date: dateStemp,
            leaveSession: 0,
            leaveCount: 1,
            isHalfDay: false
          });
        }
        // }

        currentDate.setDate(currentDate.getDate() + 1);
      }

      if (isFullDayOnlyLeaveType(valuesData.leaveTypeName)) {
        daysList = daysList.map((detail) => ({
          ...detail,
          isHalfDay: false,
          leaveSession: 0,
          leaveCount: 1
        }));
      }

      setValue('leaveDetails', daysList);
      if (isHolidayDataReady) {
        leaveCount(daysList);
      }
    }
  };

  useEffect(() => {
    if (!isFullDayOnlyLeaveType(valuesData.leaveTypeName)) return;
    if (!valuesData.leaveDetails?.some((detail) => detail.isHalfDay || detail.leaveCount === 0.5)) {
      return;
    }
    resetLeaveDetailsToFullDay();
  }, [valuesData.leaveTypeName]);

  useEffect(() => {
    if (!state.modalHeader?.isEdit) return;

    const from = new Date(valuesData.startDate);
    const to = new Date(valuesData.endDate);
    if (
      !valuesData.startDate ||
      !valuesData.endDate ||
      Number.isNaN(from.getTime()) ||
      Number.isNaN(to.getTime())
    ) {
      return;
    }

    if (!state.isEditModalData?._id) {
      calculateDays(from, to);
    } else if (
      state.isEditModalData.startDate !== from.getTime() ||
      state.isEditModalData.endDate !== to.getTime()
    ) {
      calculateDays(from, to);
    } else {
      setValue('leaveDetails', state?.isEditModalData.leaveDetails);
      if (isHolidayDataReady) {
        leaveCount(state?.isEditModalData.leaveDetails);
      }
    }
  }, [valuesData.startDate, valuesData.endDate, state.modalHeader?.isEdit, isHolidayDataReady]);

  // const allowedRoles = [ADMIN, HR];

  let columnT = '';
  columnT = [
    ...(isAdminOrHr
      ? [
          {
            name: LB_TBL_COL_EMPLOYEE_NAME,
            sortField: SR_EMPLOYEE_NAME,
            selector: () => {},
            sortable: true,
            cell: (row) => {
              const name = row?.user?.name || '';
              return (
                <div className="leave-person">
                  <span
                    className={`leave-person__avatar leave-person__avatar--${getLeaveAvatarTone(name)}`}
                    aria-hidden="true"
                  >
                    {getLeaveInitials(name)}
                  </span>
                  <span className="leave-person__name" title={name}>
                    {name || '-'}
                  </span>
                </div>
              );
            }
          }
        ]
      : []),
    {
      name: LB_TBL_COL_LEAVE_TYPE,
      sortField: SR_LEAVE_TYPE,
      selector: (row) => row?.leaveType?.name || '',
      minWidth: '168px',
      grow: 1.4,
      cell: (row) => (
        <span className="leave-type-chip" title={row?.leaveType?.name || ''}>
          {row?.leaveType?.name || '-'}
        </span>
      ),
      sortable: true
    },
    {
      name: LB_TBL_COL_REQUEST_DATE,
      selector: (row) => formatDate(row?.dateOfRequest),
      minWidth: '132px',
      grow: 1,
      cell: (row) => <LeaveTableDate value={row?.dateOfRequest} />,
      sortable: false
    },
    {
      name: LB_TBL_COL_FROM,
      selector: (row) => formatDate(row?.startDate),
      minWidth: '132px',
      grow: 1,
      cell: (row) => <LeaveTableDate value={row?.startDate} />,
      sortable: false
    },
    {
      name: LB_TBL_COL_TO,
      selector: (row) => formatDate(row?.endDate),
      minWidth: '132px',
      grow: 1,
      cell: (row) => <LeaveTableDate value={row?.endDate} />,
      sortable: false
    },
    {
      name: LB_TBL_COL_DAY,
      selector: (row) => `${row.leaveTaken ?? ''} ${row.leaveUnit || ''}`.trim(),
      width: '128px',
      grow: 0,
      center: true,
      cell: (row) => (
        <span className="leave-days-chip">
          <strong>{row.leaveTaken ?? '-'}</strong>
          <span>{formatLeaveUnit(row.leaveUnit, row.leaveTaken)}</span>
        </span>
      ),
      sortable: false
    },
    {
      name: LB_TBL_COL_STATUS,
      selector: (row) => row?.leaveStatus || '',
      width: '132px',
      grow: 0,
      cell: (row) => <LeaveStatusPill status={row?.leaveStatus} />,
      sortable: false
    },
    ...(tabClick !== PENDING
      ? [
          {
            name: LB_TBL_COL_APPROVED_BY,
            selector: (row) => row?.approvedBy?.name || '',
            minWidth: '168px',
            width: '190px',
            grow: 0,
            cell: (row) => <LeaveApprovedByCell row={row} />,
            sortable: false
          }
        ]
      : [])
  ];

  if (isAdminOrHr) {
    columnT.push({
      name: LB_TBL_COL_ACTION,
      selector: () => {},
      sortable: false,
      width: '84px',
      right: true,
      cell: (row) => (
        <RowActionMenu
          actions={[
            {
              label: 'View',
              icon: 'icofont-eye-alt',
              onClick: () => {
                setState({
                  ...state,
                  isEditModalData: row,
                  isView: { status: true }
                });
              }
            },
            {
              label: 'Edit',
              icon: 'icofont-edit',
              variant: 'success',
              hidden: row.leaveStatus === ACCEPTED,
              onClick: () => {
                openLeaveRequestModal({
                  title: LB_EDIT_LEAVE_REQUEST,
                  isEditModalData: row
                });
              }
            }
          ]}
        />
      )
    });
  } else {
    columnT.push({
      name: LB_TBL_COL_ACTION,
      selector: () => {},
      sortable: false,
      width: '84px',
      right: true,
      cell: (row) => (
        <RowActionMenu
          actions={[
            {
              label: 'View',
              icon: 'icofont-eye-alt',
              onClick: () => {
                setState({
                  ...state,
                  isEditModalData: row,
                  isView: { status: true }
                });
              }
            }
          ]}
        />
      )
    });
  }
  // This code is intended for future reference for leave request page Action
  // else {
  //   columnT.push({
  //     name: LB_TBL_COL_ACTION,
  //     selector: () => {},
  //     sortable: false,
  //     cell: (row) => (
  //       <div className="btn-group" role="group" aria-label="Basic outlined example">
  //         <button
  //           className="btn btn-outline-secondary"
  //           onClick={() => {
  //             setState({
  //               ...state,
  //               isEditModalData: row,
  //               modalHeader: { title: LB_LEAVE_REQUEST, isEdit: true },
  //               isView: { status: true }
  //             });
  //           }}
  //         >
  //           <i className="icofont-eye-alt"></i>
  //         </button>
  //       </div>
  //     )
  //   });
  // }

  const leaveTypeOptions = [
    { label: 'All', value: 'all' },
    ...visibleLeaveTypes.map((item) => ({
      label: item.name,
      value: item._id
    }))
  ];
  const handleAddLeaveRequest = async (leaveRequest) => {
    try {
      setState((prevState) => ({ ...prevState, loading: true }));
      const res = await addLeaveRequest(leaveRequest);
      if (res.data?.success) {
        leaveRequestRefetch();
        leaveCountRefetch();
        leaveBalanceRefetch();
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
        closeLeaveRequestModal();
      } else {
        closeLeaveRequestModal();
        notification(res?.error?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      setState((prevState) => ({ ...prevState, loading: false }));
      notification(error.message, TOAST_ERROR);
    }
  };

  const handleEditLeaveRequest = async (leaveRequest, id) => {
    try {
      setState((prevState) => ({ ...prevState, loading: true }));
      const res = await EditLeaveRequest({ data: leaveRequest, id: id });
      if (res.data?.success) {
        leaveRequestRefetch();
        leaveCountRefetch();
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
        closeLeaveRequestModal({
          isDeleteModal: { status: false, id: '' },
          isEditModal: { status: false, id: '' },
          rejectReason: '',
          reason: ''
        });
      } else {
        closeLeaveRequestModal({
          isDeleteModal: { status: false, id: '' },
          isEditModal: { status: false, id: '' },
          rejectReason: '',
          reason: ''
        });
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
    } catch (error) {
      setState((prevState) => ({ ...prevState, loading: false }));
      notification(error.message, TOAST_ERROR);
    }
  };

  const handleStatusChange = (status, id, reason) => {
    handleEditLeaveRequest(
      {
        leaveStatus: status,
        leaveReason: reason
      },
      id
    );
  };

  const handleAccept = () => {
    if (!state.reason) {
      setState({ ...state, reasonError: 'Reason is required' });
      return;
    }
    if (state.reason.length > 140) {
      setState({ ...state, reasonError: 'Reason must be less than 140 characters' });
      return;
    }
    handleStatusChange(ACCEPTED, state?.isEditModal.id, state.reason);
  };

  const handleReject = () => {
    if (!state.rejectReason) {
      setState({ ...state, rejectReasonError: 'Reason is required' });
      return;
    }
    if (state.rejectReason.length > 140) {
      setState({ ...state, rejectReasonError: 'Reason must be less than 140 characters' });
      return;
    }
    handleStatusChange(REJECTED, state?.isDeleteModal.id, state.rejectReason);
  };

  const onSubmit = async (data) => {
    if (Number(data.leaveTaken) <= 0) {
      notification('You cannot take a leave', TOAST_ERROR);
      return;
    }

    const end = new Date(data?.endDate).getTime();
    const start = new Date(data?.startDate).getTime();
    const userId = data.userId || (isLogin && isLogin.data && isLogin.data._id);
    const leaveRequest = {
      ...data,
      dateOfRequest: state?.isEditModalData?._id
        ? state?.isEditModalData.dateOfRequest
        : new Date().getTime(),
      endDate: end,
      startDate: start,
      leaveTaken: Number(data.leaveTaken),
      userId: userId
    };

    if (state?.isEditModalData?._id) {
      const defaultValues = state?.isEditModalData;
      const updatedValues = matchData(leaveRequest, defaultValues);
      await handleEditLeaveRequest(updatedValues, state?.isEditModalData?._id);
    } else {
      await handleAddLeaveRequest(leaveRequest);
    }
    // reset(defaultValue);
  };

  useEffect(() => {
    if (state.modalHeader?.isEdit && isAdminOrHr) {
      employeeDropDownQuery();
    }
  }, [state.modalHeader?.isEdit, isAdminOrHr]);

  useEffect(() => {
    if (data?.isNext === undefined) return;
    setState((prevState) =>
      prevState.isNext === data.isNext ? prevState : { ...prevState, isNext: data.isNext }
    );
  }, [data?.isNext]);

  const handleChangePage = (page) => {
    setState({ ...state, currentPage: page });
  };

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setState({ ...state, rowsPerPage: newRowsPerPage, currentPage: 1 });
  };

  const debouncedOnSearchData = _debounce((data) => {
    setState({ ...state, search: data });
  }, 300);

  const selectOptionList = (a, dayName, type) => {
    const dayOption = a
      ? HOLIDAY_TYPE
      : dayName === SAT || dayName === SUN
        ? WEEKEND_TYPE
        : LEAVE_DAY_TYPE;

    const option = a ? HOLIDAY_TYPE : dayName === SAT || dayName === SUN ? WEEKEND_TYPE : HALF_TYPE;

    return type ? option : dayOption;
  };

  const optionDisabled = (a, dayName, isHalfDay) => {
    const dayOption = a ? true : dayName === SAT || dayName === SUN ? true : false;
    const option = a
      ? true
      : dayName === SAT || dayName === SUN || isHalfDay === false
        ? true
        : false;

    return isHalfDay ? option : dayOption;
  };

  // const handleMenuScrollToTop = async () => {
  //   if (state.currentPage > 0) {
  //     setState({ ...state, currentPage: state.currentPage - 1 });
  //     refetchEmployee();
  //   }
  // };

  const handleMenuScrollToBottom = async () => {
    if (dropdownData?.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDropdown: prevState.currentPageDropdown + 1
      }));
      employeeDropDownQuery();
    }
  };

  useEffect(() => {
    if (!dropdownData?.data || !Array.isArray(dropdownData.data)) return;

    setState((prevState) => ({
      ...prevState,
      dropdownDataStore:
        prevState.currentPageDropdown === 1
          ? dropdownData.data
          : [...prevState.dropdownDataStore, ...dropdownData.data]
    }));
  }, [dropdownData]);

  const handleStartDateChange = (event) => {
    const startDateValue = event.target.value;
    setValue('startDate', startDateValue);
    trigger('startDate');

    if (startDateValue > valuesData?.endDate) {
      setValue('endDate', startDateValue);
      trigger('endDate');
    }
  };

  const handleEndDateChange = (event) => {
    const endDateValue = event.target.value;
    setValue('endDate', endDateValue);
    trigger('endDate');
  };

  const handleLeaveTypeFilter = (val) => {
    const nextPage = 1;
    setState((prevState) => ({
      ...prevState,
      leaveTypeFilter: val,
      currentPage: nextPage
    }));
    forceLeaveRequestFetch({ leaveTypeFilter: val, page: nextPage });
  };

  const handleDateFilter = (val) => {
    setPeriodFilter(val);
    if (val !== DATE_FILTER_KEYS.CUSTOM) {
      setCustomDateRange(initialCustomDateRange);
      const { start, end } = RANGES[val];
      const nextPage = 1;
      setState((prevState) => ({
        ...prevState,
        startDate: start,
        endDate: end,
        currentPage: nextPage
      }));
      forceLeaveRequestFetch({ startDate: start, endDate: end, page: nextPage });
    } else {
      setCustomDateRange((pre) => ({
        ...pre,
        isCustom: true,
        startDate: null,
        endDate: null,
        startOpen: false,
        endOpen: false
      }));
    }
  };

  const handleCustomRangeClear = () => {
    setCustomDateRange({
      ...initialCustomDateRange,
      isCustom: true,
      startOpen: false,
      endOpen: false
    });
  };

  const isRangeCleared = (value) => !value?.[0] && !value?.[1];

  // Date Range Picker
  const onStartChange = (value) => {
    if (isRangeCleared(value)) {
      handleCustomRangeClear();
      return;
    }

    setCustomDateRange((pre) => ({
      ...pre,
      startDate: value[0],
      endDate: value[1] ?? null,
      startOpen: false,
      endOpen: Boolean(value[0] && !value[1])
    }));
  };

  const onEndChange = (value) => {
    if (isRangeCleared(value)) {
      handleCustomRangeClear();
      return;
    }

    if (!value?.[0] || !value?.[1]) return;

    const start = moment(value[0]).startOf('day');
    const end = moment(value[1]).endOf('day');

    setCustomDateRange((pre) => ({
      ...pre,
      startDate: start,
      endDate: end,
      startOpen: false,
      endOpen: false
    }));

    const nextStart = start.valueOf();
    const nextEnd = end.valueOf();
    const nextPage = 1;

    setState((prevState) => ({
      ...prevState,
      startDate: nextStart,
      endDate: nextEnd,
      currentPage: nextPage
    }));
    forceLeaveRequestFetch({ startDate: nextStart, endDate: nextEnd, page: nextPage });
  };

  const onStartOpenChange = (startOpen) => {
    setCustomDateRange((pre) => ({
      ...pre,
      startOpen: startOpen
    }));
  };

  const onEndOpenChange = (endOpen) => {
    setCustomDateRange((pre) => ({
      ...pre,
      endOpen: endOpen
    }));
  };

  const disabledStartDate = (endValue) => {
    if (!endValue) {
      return false;
    }
    if (!customDateRange.startDate) {
      return false;
    }
    return endValue.diff(customDateRange.startDate, 'days') < 0;
  };

  // const handleAddCustomStartDate = (value) => {
  //   const startDate = moment
  //     .utc(value)
  //     .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  //     .format();

  //   setCustomDateRange((pre) => ({
  //     ...pre,
  //     startDate
  //   }));
  // };

  const viewRequest = state?.isEditModalData || {};
  const viewEmployeeName = viewRequest?.user?.name || '';

  return (
    <div className="container-xxl leave-page">
      <header className="leave-page-head">
        <div className="leave-page-head__copy">
          <h1 className="leave-page-head__title">{LB_LEAVE_REQUEST}</h1>
        </div>
      </header>

      {!isAdminOrHr && (
        <div className="leave-balance-strip mb-4">
          <div className="leave-balance-strip__top">
            <div className="leave-balance-strip__title-wrap">
              <h2 className="leave-balance-strip__title">Leave Balances</h2>
            </div>
            <div className="leave-balance-strip__top-actions">
              <div className="leave-balance-strip__legend">
                <span className="leave-balance-strip__legend-item">
                  <i className="leave-balance-strip__legend-dot leave-balance-strip__legend-dot--avail" />
                  Avail
                </span>
                <span className="leave-balance-strip__legend-item">
                  <i className="leave-balance-strip__legend-dot leave-balance-strip__legend-dot--used" />
                  Used
                </span>
                <span className="leave-balance-strip__legend-item">
                  <i className="leave-balance-strip__legend-dot leave-balance-strip__legend-dot--total" />
                  Total
                </span>
              </div>
              <button
                type="button"
                onClick={openApplyLeaveModal}
                className="leave-link-btn leave-link-btn--sm"
              >
                {BTN_APPLY_LEAVE}
              </button>
            </div>
          </div>

          <div className="leave-balance-mini-wrap">
            <div className="leave-balance-mini">
              {employeeLeaveTypes.length > 0 &&
                employeeLeaveTypes.map((leaveType) => {
                  const { used, available, total } = getLeaveBalanceMetrics(leaveType);
                  const isUsageOnly = isUsageTrackedLeaveType(leaveType?.name);
                  const usedPercent = total > 0 ? Math.min((used / total) * 100, 100) : 0;

                  return (
                    <div className="leave-balance-mini__slot" key={leaveType?._id}>
                      <div
                        className={`leave-balance-mini__item${isUsageOnly ? ' leave-balance-mini__item--usage-only' : ''}`}
                      >
                        <div
                          className={`leave-balance-mini__ring${isUsageOnly ? ' leave-balance-mini__ring--usage-only' : ''}`}
                          style={isUsageOnly ? undefined : { '--used-progress': `${usedPercent}%` }}
                        >
                          <span className="leave-balance-mini__ring-val">
                            {isUsageOnly ? used : available}
                          </span>
                          <span className="leave-balance-mini__ring-lbl">
                            {isUsageOnly ? 'used' : 'avail'}
                          </span>
                        </div>
                        <div className="leave-balance-mini__meta">
                          <span className="leave-balance-mini__name" title={leaveType?.name}>
                            {leaveType?.name}
                          </span>
                          {!isUsageOnly && (
                            <>
                              <div className="leave-balance-mini__ratio">
                                <span className="leave-balance-mini__ratio-part">
                                  <span className="leave-balance-mini__ratio-lbl">Used</span>
                                  <span className="leave-balance-mini__ratio-used">{used}</span>
                                </span>
                                <span className="leave-balance-mini__ratio-sep">/</span>
                                <span className="leave-balance-mini__ratio-part">
                                  <span className="leave-balance-mini__ratio-lbl">Total</span>
                                  <span className="leave-balance-mini__ratio-total">{total}</span>
                                </span>
                              </div>
                              <div className="leave-balance-mini__bar-row">
                                <span className="leave-balance-mini__bar" aria-hidden="true">
                                  <span
                                    className="leave-balance-mini__bar-used"
                                    style={{ width: `${usedPercent}%` }}
                                  />
                                </span>
                                <span className="leave-balance-mini__pct">
                                  {Math.round(usedPercent)}%
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}

      <div className="row clearfix g-3">
        <div className="col-sm-12">
          <div className="leave-request-table">
            <div className="leave-request-table__toolbar">
              <div className="leave-request-table__toolbar-row">
                <div className="leave-request-table__toolbar-left">
                  <div
                    className="leave-request-table__tabs"
                    role="tablist"
                    aria-label="Leave status tabs"
                  >
                    <button
                      type="button"
                      role="tab"
                      aria-selected={tabClick === PENDING}
                      onClick={() => handleStatusTabChange(PENDING)}
                      title="Pending Leaves"
                      className={`leave-request-table__tab leave-request-table__tab--pending ${tabClick === PENDING ? 'is-active' : ''}`}
                    >
                      <span className="leave-request-table__tab-inner">
                        <i className="icofont-exclamation-circle" />
                        <span>Pending</span>
                        {typeof leaveCounts.pending === 'number' ? (
                          <span className="leave-request-table__tab-count">{leaveCounts.pending}</span>
                        ) : null}
                      </span>
                    </button>
                    <button
                      type="button"
                      role="tab"
                      aria-selected={tabClick === ACCEPTED}
                      className={`leave-request-table__tab leave-request-table__tab--approved ${tabClick === ACCEPTED ? 'is-active' : ''}`}
                      onClick={() => handleStatusTabChange(ACCEPTED)}
                      title="Approved Leave"
                    >
                      <span className="leave-request-table__tab-inner">
                        <i className="icofont-check-circled" />
                        <span>Approved</span>
                        {typeof leaveCounts.approved === 'number' ? (
                          <span className="leave-request-table__tab-count">{leaveCounts.approved}</span>
                        ) : null}
                      </span>
                    </button>
                    <button
                      type="button"
                      role="tab"
                      aria-selected={tabClick === REJECTED}
                      onClick={() => handleStatusTabChange(REJECTED)}
                      title="Rejected Leaves"
                      className={`leave-request-table__tab leave-request-table__tab--rejected ${tabClick === REJECTED ? 'is-active' : ''}`}
                    >
                      <span className="leave-request-table__tab-inner">
                        <i className="icofont-close-circled" />
                        <span>Rejected</span>
                        {typeof leaveCounts.rejected === 'number' ? (
                          <span className="leave-request-table__tab-count">{leaveCounts.rejected}</span>
                        ) : null}
                      </span>
                    </button>
                  </div>
                </div>

                <div className="leave-request-table__controls">
                  <div className="leave-request-table__filter-fields">
                    <div className="leave-request-table__field leave-request-table__field--type">
                      <span className="leave-request-table__field-label">Leave type</span>
                      <SingleSelectBox
                        handleSelectedData={(val) => {
                          handleLeaveTypeFilter(val);
                        }}
                        options={leaveTypeOptions}
                        error={''}
                      />
                    </div>
                    <div className="leave-request-table__field leave-request-table__field--period">
                      <span className="leave-request-table__field-label">Period</span>
                      <SingleSelectBox
                        value={periodFilter}
                        handleSelectedData={(val) => {
                          handleDateFilter(val);
                        }}
                        options={DATE_FILTER}
                        error={''}
                      />
                    </div>
                    {customDateRange?.isCustom && (
                      <div className="leave-request-table__field leave-request-table__field--range">
                        <span className="leave-request-table__field-label">Custom range</span>
                        <div className="leave-request-table__date-range">
                          <DateRangePicker
                            startValue={customDateRange?.startDate}
                            endValue={customDateRange?.endDate}
                            onStartChange={onStartChange}
                            onEndChange={onEndChange}
                            disabledStartDate={disabledStartDate}
                            startOpen={customDateRange?.startOpen}
                            endOpen={customDateRange?.endOpen}
                            onStartOpenChange={onStartOpenChange}
                            onEndOpenChange={onEndOpenChange}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {isAdminOrHr && (
                    <div className="leave-request-table__field leave-request-table__field--search">
                      <span className="leave-request-table__field-label">Search</span>
                      <div className="leave-request-table__search">
                        <i className="icofont-search leave-request-table__search-icon" />
                        <input
                          className="form-control leave-request-table__search-input"
                          placeholder={PH_SEARCH_INPUT}
                          onChange={(e) => {
                            debouncedOnSearchData(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {isAdminOrHr && (
                    <div className="leave-request-table__field leave-request-table__field--action">
                      <span
                        className="leave-request-table__field-label leave-request-table__field-label--spacer"
                        aria-hidden="true"
                      >
                        &nbsp;
                      </span>
                      <button
                        type="button"
                        className="btn leave-request-table__apply-btn"
                        onClick={openApplyLeaveModal}
                      >
                        <i className="icofont-plus-circle" />
                        {BTN_APPLY_LEAVE}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="leave-request-table__body">
              <DataTable
                title={LeaveRequestData.title}
                columns={columnT}
                data={data?.data || []}
                // customStyles={{
                //   rows:{style:{
                //     ":first-child":{

                //     }
                //   }}
                // }}
                defaultSortField="title"
                pagination
                paginationServer
                onSort={handleChangeSort}
                sortField={state.sortField}
                sortDirection={state.sortDirection}
                paginationTotalRows={paginationRow(
                  data?.isNext,
                  state.rowsPerPage,
                  state.currentPage,
                  data?.data?.length,
                  data?.totalCount
                )}
                paginationPerPage={state.rowsPerPage}
                paginationRowsPerPageOptions={[5, 10, 20, 30]}
                paginationComponentOptions={{
                  noRowsPerPage: false,
                  rangeSeparatorText: 'of',
                  selectAllRowsItem: state.isNext,
                  selectAllRowsItemText: 'All'
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                selectableRows={false}
                noDataComponent={<EmptyData />}
                className="leave-request-table__datatable"
                customStyles={leaveRequestTableStyles}
                highlightOnHover={true}
                progressPending={isLoading || isFetching}
                progressComponent={<TableSkeleton columns={7} />}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        centered
        scrollable
        className="leave-request-modal"
        dialogClassName="leave-request-modal__dialog"
        contentClassName="leave-request-modal__content"
        show={state.modalHeader?.isEdit}
        onHide={() => closeLeaveRequestModal()}
      >
        <Modal.Header className="leave-request-modal__header" closeButton>
          <div className="leave-request-modal__header-content">
            <span className="leave-request-modal__header-icon" aria-hidden="true">
              <i className="icofont-calendar" />
            </span>
            <div>
              <Modal.Title className="leave-request-modal__title">
                {state.modalHeader.title}
              </Modal.Title>
              <p className="leave-request-modal__subtitle">
                Fill in the details below to submit your request
              </p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="leave-request-modal__body">
          <div className="leave-request-modal__form">
            <form key={state.formResetKey} id="leaveRequestForm" onSubmit={handleSubmit(onSubmit)}>
              <div className="leave-request-modal__section leave-request-modal__section--main">
                <div className="leave-request-modal__section-head">
                  <span className="leave-request-modal__section-title">Leave details</span>
                </div>
                <div className="row g-3">
                  <div className={`col-12${isAdminOrHr ? ' col-md-6' : ''}`}>
                    <div className="leave-request-modal__field">
                      <label className="leave-request-modal__label">{LEAVE_TYPE_INPUT_LABEL}</label>
                      <div className="leave-request-modal__input-wrap">
                        <select
                          className="form-select leave-request-modal__select"
                          {...register('leaveTypeId')}
                          disabled={state?.isView?.status}
                          onChange={(e) => {
                            const selectedId = e.target.value;
                            const selectedName = e.target.options[e.target.selectedIndex].text;

                            setValue('leaveTypeId', selectedId);
                            setValue('leaveTypeName', selectedName);

                            if (isFullDayOnlyLeaveType(selectedName)) {
                              resetLeaveDetailsToFullDay();
                            }
                          }}
                        >
                          <option value="" className="d-none">
                            {PH_SELECT_LEAVE_TYPE}
                          </option>
                          {visibleLeaveTypes.length > 0
                            ? visibleLeaveTypes.map((leaveType) => (
                                <option key={leaveType._id} value={leaveType._id}>
                                  {leaveType.name}
                                </option>
                              ))
                            : null}
                        </select>
                      </div>
                      {selectedLeaveTypeBalance && (
                        <div className="leave-request-modal__balance-chips">
                          {(() => {
                            const { used, available, total } =
                              getLeaveBalanceMetrics(selectedLeaveTypeBalance);
                            const isUsageOnly = isUsageTrackedLeaveType(
                              selectedLeaveTypeBalance?.name
                            );

                            if (isUsageOnly) {
                              return (
                                <span className="leave-request-modal__balance-chip">
                                  <span className="leave-request-modal__balance-chip-label">
                                    Used
                                  </span>
                                  <span className="leave-request-modal__balance-chip-value">
                                    {used}
                                  </span>
                                </span>
                              );
                            }

                            return (
                              <>
                                <span className="leave-request-modal__balance-chip leave-request-modal__balance-chip--primary">
                                  <span className="leave-request-modal__balance-chip-label">
                                    Available
                                  </span>
                                  <span className="leave-request-modal__balance-chip-value">
                                    {available}
                                  </span>
                                </span>
                                <span className="leave-request-modal__balance-chip">
                                  <span className="leave-request-modal__balance-chip-label">
                                    Used
                                  </span>
                                  <span className="leave-request-modal__balance-chip-value">
                                    {used}
                                  </span>
                                </span>
                                <span className="leave-request-modal__balance-chip">
                                  <span className="leave-request-modal__balance-chip-label">
                                    Total
                                  </span>
                                  <span className="leave-request-modal__balance-chip-value">
                                    {total}
                                  </span>
                                </span>
                              </>
                            );
                          })()}
                        </div>
                      )}
                      <small className="text-danger">
                        {getErrorMessage('leaveTypeId', errors)}
                      </small>
                    </div>
                  </div>
                  {isAdminOrHr && (
                    <div className="col-12 col-md-6">
                      <div className="leave-request-modal__field">
                        <label className="leave-request-modal__label">{LB_USER}</label>
                        <Select
                          className="leave-request-modal__employee-select"
                          classNamePrefix="leave-request-employee"
                          options={employeeOptions}
                          onChange={(selectedOption) => {
                            setValue('userId', selectedOption?.value || '');
                          }}
                          value={
                            valuesData?.userId
                              ? employeeOptions.find(
                                  (option) => option.value === valuesData.userId
                                ) ||
                                (state?.isEditModalData?.user?._id
                                  ? {
                                      value: state.isEditModalData.user._id,
                                      label: state.isEditModalData.user.name
                                    }
                                  : null)
                              : null
                          }
                          onMenuOpen={handleEmployeeMenuOpen}
                          onMenuScrollToBottom={handleMenuScrollToBottom}
                          isLoading={isEmployeeDropdownFetching}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 100000 })
                          }}
                          placeholder="Select employee..."
                          isDisabled={!!state.isEditModalData?.user?._id}
                        />
                        <small className="text-danger">{getErrorMessage('userId', errors)}</small>
                      </div>
                    </div>
                  )}
                </div>

                <div className="leave-request-modal__date-group">
                  <div className="leave-request-modal__date-flow">
                    <div className="leave-request-modal__date-field">
                      <label htmlFor="datepickerdedass" className="leave-request-modal__label">
                        {LB_TBL_COL_FROM_DATE}
                      </label>
                      <div className="leave-request-modal__date-input">
                        <input
                          type="date"
                          className={`form-control leave-request-modal__control leave-request-modal__control--date${isHolidayDataPending ? ' leave-request-modal__control--disabled' : ''}`}
                          value={valuesData?.startDate}
                          id="datepickerdedass"
                          disabled={isHolidayDataPending}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={handleStartDateChange}
                        />
                      </div>
                      <small className="text-danger">{getErrorMessage('startDate', errors)}</small>
                    </div>
                    <span className="leave-request-modal__date-arrow" aria-hidden="true">
                      <i className="icofont-long-arrow-right" />
                    </span>
                    <div className="leave-request-modal__date-field">
                      <label htmlFor="datepickerdedoneddsd" className="leave-request-modal__label">
                        {LB_TBL_COL_TO_DATA}
                      </label>
                      <div className="leave-request-modal__date-input">
                        <input
                          disabled={!valuesData.startDate || isHolidayDataPending}
                          min={valuesData.startDate}
                          value={
                            valuesData?.startDate > valuesData?.endDate
                              ? valuesData?.startDate
                              : valuesData?.endDate
                          }
                          onKeyDown={(e) => e.preventDefault()}
                          type="date"
                          className={`form-control leave-request-modal__control leave-request-modal__control--date${valuesData.startDate && !isHolidayDataPending ? '' : ' leave-request-modal__control--disabled'}`}
                          onChange={handleEndDateChange}
                          id="datepickerdedoneddsd"
                        />
                      </div>
                      <small className="text-danger">{getErrorMessage('endDate', errors)}</small>
                    </div>
                  </div>
                  {isHolidayDataPending ? (
                    <small className="text-muted d-block mt-1">Loading holidays…</small>
                  ) : null}
                </div>

                <div className="leave-request-modal__field leave-request-modal__field--reason">
                  <label
                    htmlFor="exampleFormControlTextarea78d"
                    className="leave-request-modal__label"
                  >
                    {LB_LEAVE_REASON}
                  </label>
                  <textarea
                    className="form-control leave-request-modal__textarea"
                    placeholder={PH_LEAVE_REASON}
                    {...register('note')}
                    id="exampleFormControlTextarea78d"
                    rows="2"
                  ></textarea>
                  <small className="text-danger">{getErrorMessage('note', errors)}</small>
                </div>
              </div>
              {valuesData.leaveDetails?.length > 0 && (
                <div className="leave-request-modal__section leave-request-modal__section--days">
                  <div className="leave-request-modal__section-head leave-request-modal__section-head--days">
                    <span className="leave-request-modal__section-title">Day breakdown</span>
                    <div className="leave-request-modal__days-pills">
                      <span className="leave-request-modal__days-pill">
                        <strong>{valuesData.leaveDetails.length}</strong> calendar
                      </span>
                      <span className="leave-request-modal__days-pill leave-request-modal__days-pill--primary">
                        <strong>{state.leaveCount}</strong> leave days
                      </span>
                    </div>
                  </div>
                  <div className="leave-request-modal__days-panel">
                    <div className="leave-request-modal__days-head">
                      <span>Date</span>
                      <span>Duration</span>
                    </div>
                    {/* {valuesData.leaveDetails?.length > 0 ? (
                  <>
                    <div className="leave-main">
                      {valuesData.leaveDetails?.map((val, i) => {
                        const date = new Date(val.date);
                        const dayName = moment(date).format('ddd');
                        const filterHoliday = holidayDate?.data?.filter(
                          (value) => value.date === val.date
                        );
                        const a = filterHoliday?.length > 0 ? true : false;
                        return (
                          <div className="d-flex justify-content-between" key={i}>
                            <div className="w-50 m-1" style={{ paddingTop: '10px' }}>
                              <p>
                                {dayName} {moment(date).format('ll')}
                              </p>
                            </div>
                            <div className="w-50 m-1">
                              <SingleSelectBox
                                style={{ fontSize: '15px', backgroundColor: "#fff", borderColor: "#ccc" }}

                                value={val.isHalfDay ? HALF_DAY : FULL_DAY}
                                handleSelectedData={(val) => {
                                  handleLeaveType(val, i);
                                }}
                                disabled={optionDisabled(a, dayName)}
                                options={selectOptionList(a, dayName)}
                                error={''}
                              />
                            </div>
                            <div className="w-50 m-1">
                              {val.isHalfDay && (
                                <SingleSelectBox
                                  style={{ fontSize: '15px', backgroundColor: "#fff", borderColor: "#ccc" }}

                                  value={
                                    val.leaveSession === 0
                                      ? null
                                      : val.leaveSession === 1
                                        ? F_HALF
                                        : S_HALF
                                  }
                                  handleSelectedData={(val) => {
                                    setValue(
                                      `leaveDetails[${i}].leaveSession`,
                                      val === F_HALF ? 1 : 2
                                    );
                                  }}
                                  options={selectOptionList(a, dayName, HALF_DAY)}
                                  error={''}
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="d-flex align-items-center total-leave justify-content-between p-2 rounded-1">
                      <span>
                        <b>{LB_TBL_COL_TOTAL_LEAVE}</b>
                      </span>
                      <span>
                        <b>{state.leaveCount}</b>
                      </span>
                    </div>
                  </>
                ) : null} */}
                    <div className="leave-main leave-request-modal__days-list">
                      {valuesData.leaveDetails?.map((val, i) => {
                        const date = new Date(val.date);
                        const dayName = moment(date).format('ddd');
                        const isWeekend = dayName === 'Sat' || dayName === 'Sun';
                        const filterHoliday = holidayDate?.data?.filter(
                          (value) => value.date === val.date
                        );
                        const a = filterHoliday?.length > 0 ? true : false;
                        const isFullDayOnly = isFullDayOnlyLeaveType(valuesData.leaveTypeName);

                        return (
                          <div
                            key={i}
                            className={`leave-day-row leave-item${isFullDayOnly ? ' leave-day-row--full-day-only' : ''}${isWeekend ? ' leave-day-row--weekend' : ''}${a ? ' leave-day-row--holiday' : ''}`}
                          >
                            <div
                              className={`leave-day-row__date ${
                                isWeekend ? 'is-weekend' : a ? 'is-holiday' : ''
                              }`}
                            >
                              <span className="leave-day-row__mark" aria-hidden>
                                <span className="leave-day-row__day">{dayName}</span>
                                <span className="leave-day-row__num">
                                  {moment(date).format('DD')}
                                </span>
                              </span>
                              <span className="leave-day-row__meta">
                                <span className="leave-day-row__date-text">
                                  {moment(date).format('MMMM')}
                                </span>
                                <span className="leave-day-row__year">
                                  {moment(date).format('YYYY')}
                                </span>
                              </span>
                            </div>

                            <div className="leave-day-row__controls">
                              {isFullDayOnly ? (
                                <span className="leave-day-row__full-day-badge">{FULL_DAY}</span>
                              ) : (
                                <>
                                  <div className="leave-day-row__duration leave-request-modal__day-select">
                                    <SingleSelectBox
                                      value={val.isHalfDay ? HALF_DAY : FULL_DAY}
                                      handleSelectedData={(val) => handleLeaveType(val, i)}
                                      disabled={optionDisabled(a, dayName)}
                                      options={selectOptionList(a, dayName)}
                                      error={''}
                                    />
                                  </div>
                                  {val.isHalfDay && (
                                    <div className="leave-day-row__session leave-request-modal__day-select">
                                      <SingleSelectBox
                                        value={
                                          val.leaveSession === 0
                                            ? null
                                            : val.leaveSession === 1
                                              ? F_HALF
                                              : S_HALF
                                        }
                                        handleSelectedData={(val) => {
                                          setValue(
                                            `leaveDetails[${i}].leaveSession`,
                                            val === F_HALF ? 1 : 2
                                          );
                                        }}
                                        options={selectOptionList(a, dayName, HALF_DAY)}
                                        error={''}
                                      />
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer className="leave-request-modal__footer">
          <button
            type="submit"
            form="leaveRequestForm"
            disabled={state.loading || isHolidayDataPending}
            className="btn leave-request-modal__submit-btn"
          >
            {state.loading ? (
              <div className="spinner-border spinner-border-sm" role="status"></div>
            ) : (
              <>
                <i className="icofont-check-circled leave-request-modal__submit-icon" />
                {BTN_SAVE}
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        centered
        className="leave-request-modal leave-view-modal"
        dialogClassName="leave-view-modal__dialog"
        contentClassName="leave-request-modal__content"
        show={state?.isView?.status}
        onHide={() => {
          setState({ ...state, isView: { status: false }, isEditModalData: {} });
        }}
      >
        <Modal.Header className="leave-request-modal__header leave-view-modal__header" closeButton>
          <div className="leave-view-modal__header-row">
            <span
              className={`leave-person__avatar leave-view__avatar leave-person__avatar--${getLeaveAvatarTone(viewEmployeeName)}`}
              aria-hidden="true"
            >
              {getLeaveInitials(viewEmployeeName)}
            </span>
            <div className="leave-view-modal__heading">
              <Modal.Title className="leave-request-modal__title">
                {viewEmployeeName || 'Leave request'}
              </Modal.Title>
              <p className="leave-request-modal__subtitle">
                <span className="leave-view__type">{viewRequest?.leaveType?.name || 'Leave'}</span>
                <span>
                  Requested{' '}
                  {viewRequest?.dateOfRequest ? formatDate(viewRequest.dateOfRequest) : '-'}
                </span>
              </p>
            </div>
            <LeaveStatusPill status={viewRequest?.leaveStatus} />
          </div>
        </Modal.Header>
        <Modal.Body className="leave-request-modal__body leave-view-modal__body">
          <div className="leave-view">
            <div className="leave-view__when">
              <div className="leave-view__date">
                <span className="leave-view__date-kicker">From</span>
                <div className="leave-view__date-body">
                  <span className="leave-view__date-num">
                    {viewRequest?.startDate ? moment(viewRequest.startDate).format('DD') : '–'}
                  </span>
                  <span className="leave-view__date-meta">
                    <strong>
                      {viewRequest?.startDate
                        ? moment(viewRequest.startDate).format('MMM YYYY')
                        : '—'}
                    </strong>
                    <span>
                      {viewRequest?.startDate ? moment(viewRequest.startDate).format('dddd') : ''}
                    </span>
                  </span>
                </div>
              </div>
              <div className="leave-view__span">
                <span className="leave-view__span-line" aria-hidden="true" />
                <div className="leave-view__span-badge">
                  <strong>{viewRequest?.leaveTaken || '–'}</strong>
                  <span>{formatLeaveUnit(viewRequest?.leaveUnit, viewRequest?.leaveTaken)}</span>
                </div>
                <span className="leave-view__span-line" aria-hidden="true" />
              </div>
              <div className="leave-view__date leave-view__date--end">
                <span className="leave-view__date-kicker">To</span>
                <div className="leave-view__date-body">
                  <span className="leave-view__date-num">
                    {viewRequest?.endDate ? moment(viewRequest.endDate).format('DD') : '–'}
                  </span>
                  <span className="leave-view__date-meta">
                    <strong>
                      {viewRequest?.endDate ? moment(viewRequest.endDate).format('MMM YYYY') : '—'}
                    </strong>
                    <span>
                      {viewRequest?.endDate ? moment(viewRequest.endDate).format('dddd') : ''}
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div className="leave-view__notes">
              <div className="leave-view__note">
                <span className="leave-view__note-label">Note</span>
                <p className={viewRequest?.note ? '' : 'is-empty'}>
                  {viewRequest?.note || 'No note added'}
                </p>
              </div>
              <div className="leave-view__note">
                <span className="leave-view__note-label">Comment</span>
                <p className={viewRequest?.leaveReason ? '' : 'is-empty'}>
                  {viewRequest?.leaveReason || 'No comment yet'}
                </p>
              </div>
              {(viewRequest?.leaveStatus === ACCEPTED || viewRequest?.leaveStatus === REJECTED) && (
                <div className="leave-view__note leave-view__note--reviewer">
                  <span className="leave-view__note-label">
                    {viewRequest?.leaveStatus === REJECTED ? 'Rejected by' : 'Approved by'}
                  </span>
                  <p className={viewRequest?.approvedBy?.name ? '' : 'is-empty'}>
                    {viewRequest?.approvedBy?.name || 'Not available'}
                  </p>
                </div>
              )}
            </div>

            <LeaveDayBreakdown leaveDetails={viewRequest?.leaveDetails} />
          </div>
        </Modal.Body>
        <Modal.Footer className="leave-request-modal__footer leave-view-modal__footer">
          <button
            type="button"
            className="btn leave-view-modal__btn leave-view-modal__btn--ghost"
            onClick={() => {
              setState({ ...state, isView: { status: false }, isEditModalData: {} });
            }}
          >
            Close
          </button>
          {canReviewLeave && state?.isEditModalData?.leaveStatus === PENDING ? (
            <>
              <button
                type="button"
                className="btn leave-view-modal__btn leave-view-modal__btn--reject"
                onClick={() => {
                  setState({
                    ...state,
                    isDeleteModal: { status: true, id: state?.isEditModalData?._id },
                    rejectReason: '',
                    rejectReasonError: ''
                  });
                }}
              >
                <i className="icofont-close-circled" />
                {REJECT_BTN}
              </button>
              <button
                type="button"
                className="btn leave-view-modal__btn leave-view-modal__btn--approve"
                onClick={() => {
                  setState({
                    ...state,
                    isEditModal: { status: true, id: state?.isEditModalData?._id },
                    reason: '',
                    reasonError: ''
                  });
                }}
              >
                <i className="icofont-check-circled" />
                {BTN_ACCEPT}
              </button>
            </>
          ) : null}
          {canReviewLeave && state?.isEditModalData?.leaveStatus === ACCEPTED ? (
            <button
              type="button"
              className="btn leave-view-modal__btn leave-view-modal__btn--reject"
              onClick={() => {
                setState({
                  ...state,
                  isDeleteModal: { status: true, id: state?.isEditModalData?._id },
                  rejectReason: '',
                  rejectReasonError: ''
                });
              }}
            >
              <i className="icofont-close-circled" />
              {REJECT_BTN}
            </button>
          ) : null}
          {canReviewLeave && state?.isEditModalData?.leaveStatus === REJECTED ? (
            <button
              type="button"
              className="btn leave-view-modal__btn leave-view-modal__btn--approve"
              onClick={() => {
                setState({
                  ...state,
                  isEditModal: { status: true, id: state?.isEditModalData?._id },
                  reason: '',
                  reasonError: ''
                });
              }}
            >
              <i className="icofont-check-circled" />
              {BTN_ACCEPT}
            </button>
          ) : null}
        </Modal.Footer>
      </Modal>

      <Modal
        centered
        className="leave-decision-modal"
        dialogClassName="leave-decision-modal__dialog"
        contentClassName="leave-decision-modal__content"
        show={state?.isEditModal.status}
        onHide={() => {
          setState({ ...state, isEditModal: { status: false, id: '' } });
        }}
      >
        <Modal.Body className="leave-decision-modal__body">
          <span
            className="leave-decision-modal__icon leave-decision-modal__icon--approve"
            aria-hidden="true"
          >
            <i className="icofont-check-circled" />
          </span>
          <h5 className="leave-decision-modal__title" id="dremovetaskLabel">
            {LB_APPROVE}
          </h5>
          <p className="leave-decision-modal__text">{LB_ASK_LEAVE_APPROVE}</p>
          <label className="leave-decision-modal__label" htmlFor="leaveApproveReason">
            Comment
          </label>
          <textarea
            id="leaveApproveReason"
            rows={4}
            maxLength={140}
            className={`form-control leave-decision-modal__textarea ${state.reasonError ? 'is-invalid' : ''}`}
            placeholder="Enter reason"
            value={state.reason}
            onChange={(e) => setState({ ...state, reason: e.target.value, reasonError: '' })}
          />
          {state.reasonError ? (
            <div className="invalid-feedback d-block">{state.reasonError}</div>
          ) : null}
          <div className="leave-decision-modal__actions">
            <button
              type="button"
              className="btn leave-decision-modal__btn leave-decision-modal__btn--ghost"
              onClick={() => setState({ ...state, isEditModal: { status: false, id: '' } })}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn leave-decision-modal__btn leave-decision-modal__btn--approve"
              onClick={handleAccept}
            >
              {BTN_ACCEPT}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        centered
        className="leave-decision-modal"
        dialogClassName="leave-decision-modal__dialog"
        contentClassName="leave-decision-modal__content"
        show={state?.isDeleteModal.status}
        onHide={() => {
          setState({ ...state, isDeleteModal: { status: false, id: '' } });
        }}
      >
        <Modal.Body className="leave-decision-modal__body">
          <span
            className="leave-decision-modal__icon leave-decision-modal__icon--reject"
            aria-hidden="true"
          >
            <i className="icofont-close-circled" />
          </span>
          <h5 className="leave-decision-modal__title" id="leaverejectLabel">
            {LB_REJECT}
          </h5>
          <p className="leave-decision-modal__text">{LB_ASK_LEAVE_REJECT}</p>
          <label className="leave-decision-modal__label" htmlFor="leaveRejectReason">
            Comment
          </label>
          <textarea
            id="leaveRejectReason"
            rows={4}
            maxLength={140}
            className={`form-control leave-decision-modal__textarea ${state.rejectReasonError ? 'is-invalid' : ''}`}
            placeholder="Enter reason"
            value={state.rejectReason}
            onChange={(e) =>
              setState({ ...state, rejectReason: e.target.value, rejectReasonError: '' })
            }
          />
          {state.rejectReasonError ? (
            <div className="invalid-feedback d-block">{state.rejectReasonError}</div>
          ) : null}
          <div className="leave-decision-modal__actions">
            <button
              type="button"
              className="btn leave-decision-modal__btn leave-decision-modal__btn--ghost"
              onClick={() => setState({ ...state, isDeleteModal: { status: false, id: '' } })}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn leave-decision-modal__btn leave-decision-modal__btn--reject"
              onClick={handleReject}
            >
              {REJECT_BTN}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default LeaveRequest;

// {[MANAGEMENT, EMPLOYEE, LEAD].includes(isLogin?.data?.roleId?.roleName) && (
//   <div className="row">
//     {leaveTypeDataByUser?.data?.length > 0 &&
//       leaveTypeDataByUser?.data.map((leaveType, index) => {
//         const leaveData = leaveBalanceData?.data?.find(
//           (item) => item._id === isLogin?.data?._id
//         );

//         const leaveTypeInfo = leaveData?.leaveType.find((lt) => lt._id === leaveType._id);

//         // Check if leaveType is WFH and if Work From Home is allowed
//         if (leaveType?.name === LEAVE_TYPES.WFH && !isLogin?.data?.allowWorkFromHome) {
//           return null; // Don't render WFH card if Work From Home is not allowed
//         }

//         return (
//           <div key={index} className="col-xl-4 col-lg-6 col-md-12 mb-4">
//             <Card className="shadow-sm border-0 rounded-3">
//               <Card.Body className="p-3 d-flex flex-column">
//                 {/* Header Section: Leave Type with Status */}
//                 <div className="d-flex justify-content-between align-items-center mb-4">
//                   <div>
//                     <Card.Title className="fw-bold" style={{ fontSize: '1.1rem' }}>
//                       {leaveType?.name.toUpperCase()}
//                     </Card.Title>
//                   </div>
//                   <div>
//                     {/* Status Icon (Green Check Mark) */}
//                     <i
//                       className="icofont-check-circled text-success"
//                       style={{
//                         fontSize: '20px',
//                         backgroundColor: '#e9f7ef',
//                         borderRadius: '50%',
//                         padding: '6px'
//                       }}
//                     ></i>
//                   </div>
//                 </div>

//                 {/* Leave Balance Info Section */}
//                 <div
//                   className={`d-flex ${leaveType?.name !== LEAVE_TYPES.WFH ? 'justify-content-between' : 'justify-content-end'}`}
//                 >
//                   {leaveType?.name !== LEAVE_TYPES.WFH && (
//                     <div className="text-center">
//                       <h6 className="text-muted" style={{ fontSize: '0.85rem' }}>
//                         {LB_AVAILABLE}
//                       </h6>
//                       <div className="fw-bold" style={{ fontSize: '1rem' }}>
//                         {leaveTypeInfo?.availableBalance || 0}
//                       </div>
//                     </div>
//                   )}
//                   <div className="text-center">
//                     <h6 className="text-muted" style={{ fontSize: '0.85rem' }}>
//                       {leaveType?.name === LEAVE_TYPES.WFH ? LB_USED : LB_BOOKED}
//                     </h6>
//                     <div className="fw-bold" style={{ fontSize: '1rem' }}>
//                       {leaveTypeInfo?.bookedBalance || 0}
//                     </div>
//                   </div>
//                 </div>
//               </Card.Body>
//             </Card>
//           </div>
//         );
//       })}
//   </div>
// )}
